import type { ApiError } from '@okn/shared';
import { env } from './env.ts';

export class ApiRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: ApiError,
  ) {
    super(body.error.message);
    this.name = 'ApiRequestError';
  }
}

export type RequestOpts = Omit<RequestInit, 'body'> & { body?: unknown };

export async function api<T>(path: string, opts: RequestOpts = {}): Promise<T> {
  const { body, headers, ...rest } = opts;
  const res = await fetch(`${env.VITE_API_BASE_URL}${path}`, {
    ...rest,
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
      ...headers,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
    credentials: 'include',
  });

  if (!res.ok) {
    let parsed: ApiError;
    try {
      parsed = (await res.json()) as ApiError;
    } catch {
      parsed = { error: { code: 'NETWORK_ERROR', message: res.statusText } };
    }
    throw new ApiRequestError(res.status, parsed);
  }

  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
